module.exports = __webpack_public_path__ + "static/media/inesdewit.250b415a.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/inesdewit.webp
// module id = 718
// module chunks = 0